
import {  FaFacebook, FaLinkedin, FaTwitter } from 'react-icons/fa';
export const links = [
    {id: 1,
     link: '#',
     title: 'Home'
    }, 
    
    {id: 2,
    link: '#about',
    title: 'About'
   },

   {id: 3,
    link: '#price',
    title: 'Pricing'
   },
   {id: 3,
    link: '#contact',
    title: 'Contact'
   },
   {id: 4,
    link: '#HowItWorks',
    title: 'How It Works'
   },
  //  {id: 5,
  //   link: '#faqs',
  //   title: 'FAQs'
  //  }
]


export const social = [
    {
      id: 1,
      url: 'https://www.facebook.com/Dviews',
      icon: <FaFacebook />,
    },
    {
      id: 2,
      url: 'https://www.twitter.com/Dviews',
      icon: <FaTwitter />,
    },
    {
      id: 3,
      url: 'https://www.instagram.com/Dviews',
      icon: <FaLinkedin />,
    },
   
  ];
  